import type { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({
  children,
  transparentNav = false,
}: {
  children: ReactNode;
  transparentNav?: boolean;
}) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar transparent={transparentNav} />
      <main className={transparentNav ? "" : "pt-20"}>{children}</main>
      <Footer />
    </div>
  );
}